<template>
  <div
    v-if="smsHistoryDialogObj && smsHistoryDialogObj.visible"
    id="sms-history-dialog"
  >
    <div v-if="showType === 'mobile'" class="wrap-phone">
      <i
        class="el-icon-full-screen"
        style="
          position: absolute;
          right: 30px;
          top: 90px;
          z-index: 300;
          cursor: pointer;
        "
        @click="switchShowType()"
      ></i>
      <i @click="HandleCancel()" class="el-icon-close sms-close" />
      <img class="phone" src="@/assets/images/phone.png" alt="" />
      <div class="wrap-top-info">
        <span v-if="clock" class="clock">{{
          `${clock.split(":")[0]}:${clock.split(":")[1]}`
        }}</span>
        <img class="sms-people" src="@/assets/images/sms-people.png" alt="" />
        <div class="phone-number">{{ smsHistoryDialogObj.username }}</div>
      </div>
      <div class="content-sms-area">
        <ul v-if="dataList && dataList.length > 0">
          <li v-for="(item, index) in dataList" :key="index">
            <div class="sms-time">{{ item.receivedTime }}</div>
            <p>
              {{ item.content }}
              <img class="sms-tail" src="@/assets/images/sms-tail.png" alt="" />
            </p>
          </li>
          <li v-if="dataList.length < total" id="end">
            <span>老命加载中...</span>
          </li>
        </ul>
        <ul v-else class="no-data">
          <li>暂无短信</li>
        </ul>
      </div>
      <div class="wrap-footer">
        <img class="sms-footer" src="@/assets/images/sms-footer.png" alt="" />
      </div>
    </div>
    <div v-else-if="showType === 'table'" class="wrap-table">
      <i
        class="el-icon-mobile"
        style="
          position: absolute;
          right: 40px;
          top: 10px;
          z-index: 30;
          cursor: pointer;
        "
        @click="switchShowType()"
      ></i>
      <i @click="HandleCancel()" class="el-icon-close sms-table-close" />
      <div class="table-container">
        <el-table
          border
          stripe
          ref="table"
          v-loading="lockLoading"
          element-loading-background="rgba(255, 255, 255, 0.8)"
          element-loading-spinner="el-icon-loading"
          :data="dataList"
        >
          <el-table-column width="80" prop="id" label="ID" />
          <el-table-column prop="content" label="所有上传短信" />
          <el-table-column width="160" prop="fromPhoneNumber" label="来源" />
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageQuery.pageNum"
        :limit.sync="pageQuery.pageSize"
        @pagination="getSmsAllHistoryList()"
      />
    </div>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import { getSmsAllHistoryList } from "@/api/smsHistory";
import Pagination from "@/views/components/Pagination";
export default {
  mixins: [mainCommon],
  components: {
    Pagination,
  },
  props: ["smsHistoryDialogObj"],
  data() {
    return {
      showType: "", // mobile/table
      clockInterval: null,
      clock: null, // 倒数计时
      total: 0,
      pageQuery: {
        pageSize: varCommon.pagination.pageSize,
        pageNum: 1,
        username: "",
        userId: "",
      },
      dataList: [],
      lockLoading: false, // 避免 scroll 过快导致接口同时多打
    };
  },
  watch: {
    smsHistoryDialogObj(row) {
      if (row.visible) {
        this.showType = "mobile";
        this.total = 0;
        this.pageQuery = {
          pageSize: varCommon.pagination.pageSize,
          pageNum: 1,
          userId: "",
        };
        this.dataList = [];
        this.pageQuery.userId = row.userId;
        this.getSmsAllHistoryList();
        this.getClock();
        if (this.showType === "mobile") {
          window.addEventListener("keydown", this.pressEsc);
        }
      }
    },
  },
  destroyed() {
    if (this.showType === "mobile") {
      window.removeEventListener("keydown", this.pressEsc);
    }
  },
  methods: {
    switchShowType() {
      this.showType = this.showType === "table" ? "mobile" : "table";
      this.total = 0;
      this.pageQuery.pageSize = varCommon.pagination.pageSize;
      this.pageQuery.pageNum = 1;
      this.dataList = [];
      this.getSmsAllHistoryList();
    },
    onScroll() {
      if (
        this.dataList.length < this.total &&
        document.querySelector("#end").getBoundingClientRect().top > 100
      ) {
        if (!this.lockLoading) {
          this.pageQuery.pageNum++;
          this.getSmsAllHistoryList();
          this.lockLoading = true;
        }
      }
    },
    getSmsAllHistoryList() {
      this.tableLoading = true;
      getSmsAllHistoryList(this.ObjectClean(this.pageQuery)).then((res) => {
        if (res.data.list && res.data.list.length > 0) {
          this.total = res.data.total;
          if (this.showType === "mobile") {
            this.dataList = this.dataList.concat(res.data.list);
          } else {
            this.dataList = res.data.list;
          }
          this.lockLoading = false;
          if (this.showType === "mobile") {
            this.$nextTick(() => {
              document
                .querySelector(".content-sms-area ul")
                .addEventListener("scroll", this.onScroll);
            });
          }
        }
      });
    },
    getClock() {
      this.clockInterval = setInterval(() => {
        this.clock = new Date().toLocaleTimeString("zh-cn", {
          timeZone: "Asia/Shanghai",
        });
      }, 1000);
    },
    HandleCancel() {
      this.total = 0;
      this.pageQuery = {
        pageSize: varCommon.pagination.pageSize,
        pageNum: 1,
        userId: "",
      };
      this.dataList = [];
      this.lockLoading = false; // 避免 scroll 过快导致接口同时多打
      this.$emit("update:smsHistoryDialogObj", {
        visible: false,
        username: "",
        userId: "",
      });
    },
    // 按 ESC 方便键
    pressEsc(key) {
      if (key.keyCode === 27) {
        this.HandleCancel();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-icon-close.sms-close {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 10%;
  top: 5%;
  font-weight: 600;
  cursor: pointer;
  z-index: 160;
}
.wrap-phone {
  position: fixed;
  top: 6vh;
  left: 50%;
  z-index: 100;
  width: 300px;
  transform: translateX(-50%);
  overflow: hidden;
  .phone {
    position: relative;
    z-index: 100;
    width: 100%;
    height: auto;
    // background-color: #fff;
  }
  .wrap-footer {
    position: absolute;
    width: 89%;
    z-index: 60;
    bottom: 3%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #d5d8dd;
    height: 12.2%;
    img {
      width: 100%;
    }
  }
}
.wrap-top-info {
  z-index: 60;
  // background-color: blue;
  // opacity: 0.8;
  background-color: #f4f4f4;
  height: 16%;
  width: 89%;
  position: absolute;
  top: 2%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  border-bottom: 1px solid #dbdade;
  .clock {
    position: absolute;
    left: 3%;
    top: 14%;
    font-weight: 600;
    width: 32%;
    text-align: center;
  }
  .sms-people {
    margin-top: 16%;
    width: 10%;
  }
  .phone-number {
    font-size: 12px;
    font-weight: 600;
  }
}
.el-icon-close.sms-table-close {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 10px;
  top: 10px;
  font-weight: 600;
  cursor: pointer;
  z-index: 160;
}
.wrap-table {
  background-color: #fff;
  position: fixed;
  top: 10vh;
  left: 50%;
  z-index: 100;
  width: 100%;
  max-width: 800px;
  transform: translateX(-50%);
  overflow: hidden;
  padding: 10px 20px;
  box-shadow: 1px 1px 3px 1px #b0b0b0;
}
.content-sms-area {
  position: absolute;
  top: 18%;
  z-index: 100;
  // background-color: blue;
  // opacity: 0.8;
  background-color: #fff;
  width: 88.6%;
  height: 67%;
  left: 50%;
  transform: translateX(-50%);
  .no-data {
    font-size: 14px;
    font-weight: 600;
    width: 100%;
    text-align: center;
    margin-top: 60%;
    justify-content: start;
  }
  #end {
    width: 100%;
    text-align: center;
    font-size: 15px;
    margin: 0px auto 5px;
    font-weight: 600;
  }
  ul {
    margin: 0;
    overflow: hidden;
    overflow-y: auto;
    height: 100%;
    padding: 6% 10px;
    display: flex;
    flex-direction: column-reverse;
    li {
      list-style-type: none;
      .sms-time {
        width: 100%;
        text-align: center;
        color: #b8b8bb;
        font-size: 12px;
      }
      p {
        position: relative;
        font-size: 15px;
        line-height: 20px;
        width: 92%;
        margin-top: 12px;
        padding: 10px;
        border-radius: 16px;
        background: #e9e8eb;
        .sms-tail {
          width: 20px;
          position: absolute;
          left: -6px;
          bottom: -2px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/SmsHistoryDialog.vue